import * as React from 'react';
import { LinkButton, Responsive } from '@cian/ui-kit';
import { IconList16 } from '@cian/ui-kit/icons';

import { GRADIENT_ARROW_WIDTH } from '../../constants/arrows';
import { IHeadCategory } from '../../types/promosPage';
import { GradientArrowLeft } from '../GradientArrowLeft';
import { GradientArrowRight } from '../GradientArrowRight';
import { Section } from '../Section';
import { VerticalSlider } from '../VerticalSlider';

interface IHeadCategoriesProps {
  allPromos: IHeadCategory;
  categories: IHeadCategory[];
  onClick?(category: IHeadCategory, position: number): void;
}

export const HeadCategories: React.FC<IHeadCategoriesProps> = ({ allPromos, categories, onClick }) => {
  const handleClick = React.useCallback(
    (category: IHeadCategory, position: number) => () => {
      if (onClick) {
        onClick(category, position);
      }
    },
    [onClick],
  );

  return (
    <Section>
      <Responsive phone tablet>
        <LinkButton
          href={allPromos.url}
          onClick={handleClick(allPromos, 1)}
          beforeIcon={<IconList16 color="primary_100" />}
          theme="fill_secondary"
          size="M"
          fullWidth
        >
          {allPromos.name}
        </LinkButton>
      </Responsive>
      <Responsive desktop>
        <VerticalSlider
          rightArrow={GradientArrowRight}
          leftArrow={GradientArrowLeft}
          scrollOffset={GRADIENT_ARROW_WIDTH}
        >
          <LinkButton
            href={allPromos.url}
            onClick={handleClick(allPromos, 1)}
            beforeIcon={<IconList16 color="primary_100" />}
            theme="fill_secondary"
            size="M"
          >
            {allPromos.name}
          </LinkButton>
          {categories.map((category, idx) => (
            <LinkButton
              key={idx}
              href={category.url}
              onClick={handleClick(category, idx + 2)}
              theme="stroke_primary"
              size="M"
            >
              {category.name}
            </LinkButton>
          ))}
        </VerticalSlider>
      </Responsive>
    </Section>
  );
};
